// extracted by mini-css-extract-plugin
export default {"root":"Button_root__9Jch0","inner":"Button_inner__FLIaR","leftIcon":"Button_leftIcon__CyUE1","rightIcon":"Button_rightIcon__3hCQ3","text":"Button_text__9FfC+"};